import ContentCut from "@mui/icons-material/ContentCut";

import { makeSvgIcon } from "./svg-icon";

export const CutIcon = makeSvgIcon(ContentCut);

export default CutIcon;
